(function (angular) {
    'use strict';

    angular
        .module('SMART2')
        .controller('publicHeaderCtrl', ['$scope', '$rootScope', '$translate', 'APPCONSTANTS', 'PUBLICURLs', 'publicUtilities', publicHeaderCtrlFunc]);

    function publicHeaderCtrlFunc($scope, $rootScope, $translate, APPCONSTANTS, PUBLICURLs, publicUtilities) {
        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        $scope.stateOfSideBar = true; // True mean open

        $scope.sideNavComp = [];
        $rootScope.phoneContacts = [];
        $rootScope.emailContacts = [];
        /*navigation js*/
        $('.right-side-nav').sideNav({
            menuWidth: 320,
            edge: 'right',
            closeOnClick: false
        });
        if (APPCONSTANTS.userPreferences.UserBasicDetails.timeOffset) {
            localStorage.setItem('curTimeZone', JSON.stringify({ timeOffset: APPCONSTANTS.userPreferences.UserBasicDetails.timeOffset, timeZoneName: APPCONSTANTS.userPreferences.UserBasicDetails.timeZoneName }));
        }
        
        APPCONSTANTS.userPreferences.UserBasicDetails.UserName = APPCONSTANTS.userPreferences.UserName;
        $scope.logoImage = APPCONSTANTS.userPreferences.URLs.ContentURL + "cumuluscontent/logo/" + APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode + "_logo.png";;
        getRegistrationUrl();
        function getRegistrationUrl() {
            publicUtilities.makeServiceCall(PUBLICURLs.getRegistrationUrl, 'POST', null, setUrl);
        }
        function setUrl(data) {
            if (data) {
                PUBLICURLs.registrationUrl = data;
                $scope.buttonsObjects["register"].href = data;
                $rootScope.registrationUrl = data;
            }
        }
        //CONFIGURATION TO GENERATE HEADER BUTTONS AND ITS SIDE PANES
        // TODO: remove notification Count variable with value from service
        $scope.buttonsObjects = {
            howToRegister: {
                name: "How to Register?",
                class: '',
                icon: "",
                tooltip: $translate.instant('howtoregister'),
                position: "bottom",
                active: false,
                isDisable: true,
                isExternalLink: false,
                fileId: "",
                href: ""
            },
            help: {
                name: 'Help',
                class: '',
                icon: "#icon_Help",
                tooltip: $translate.instant('support'),
                position: "bottom",
                active: false,
                isDisable: false,
                templateURL: 'public/header/views/helpCenterPublicRfx.html',
                href: APPCONSTANTS.userPreferences.URLs.AppURL + "HelpCenter/HelpCenter?oloc=101"
            },
            login: {
                name: 'Login',
                class: '',
                icon: "#icon_Login",
                tooltip: $translate.instant('login'),
                position: "bottom",
                active: false,
                isDisable: true,
                isExternalLink: true,
                href: PUBLICURLs.loginUrl
            },
            register: {
                name: 'Register',
                class: '',
                icon: "#icon_Registration",
                tooltip: $translate.instant('register'),
                position: "bottom",
                active: false,
                isDisable: true,
                isExternalLink: true,
                href: ""
            }
        };
        
        if (APPCONSTANTS.userPreferences.UserBasicDetails.howToRegister && APPCONSTANTS.userPreferences.UserBasicDetails.howToRegister != 0) {
            $scope.buttonsObjects["howToRegister"].isDisable = false;
            $scope.buttonsObjects["howToRegister"].isExternalLink = true;
            $scope.buttonsObjects["howToRegister"].fileId = APPCONSTANTS.userPreferences.UserBasicDetails.howToRegister.toString();
        }
        
        $scope.$on("onHowToRegisterClick", function (event, args) {
            console.log(args, "onHowToRegisterClick");
            if(args && args.item && args.item.fileId){
                publicUtilities.downloadFile(args.item.fileId,true);
            }
        });

        $scope.logout = $translate.instant('logOut');

        $scope.lastHeaderBtnClicked = false;

        $scope.resetPanes = function (isLast) {

            var rginRight = "";
            console.log("deactivateButtons...");
            _.each($scope.buttonsObjects, function (item, key, collection) {
                item.active = false;
                item.showPane = false;
            });
            if ($scope.lastHeaderBtnClicked) {
                $scope.lastHeaderBtnClicked = false;
                if ($('.fixed-action-btn').length && $('#sidenav-overlay').length) {
                    $('.fixed-action-btn').removeAttr('style');
                }
            } else {
                $scope.lastHeaderBtnClicked = isLast;
                if ($('.fixed-action-btn').length) {
                    $('.fixed-action-btn').css('z-index', '-1');
                }
            }
            $scope.toggleOverlay(false);

            _.each($scope.buttonsObjects, function (value, key, list) {
                value.marginRight = "";

            });
            if ($('.fixed-action-btn').length && $('#sidenav-overlay').length) {
                $('.fixed-action-btn').removeAttr('style');
            }
        };

        $scope.toggleOverlay = function (val, name) {
            $scope.sidePaneVisible = val;
            if (name && name.toLowerCase() == 'help' && _.isEmpty($scope.contact) && val) {
                getHelpCenterData();
            }
        };
        function getHelpCenterData() {
            if ($rootScope.phoneContacts.length == 0 && $rootScope.emailContacts.length == 0)
                publicUtilities.makeServiceCall(PUBLICURLs.helpCenter, 'GET', null, setHelpCenterData);
        }
        function setHelpCenterData(data) {
            if (data && data[0]) {
                var helpCenter = $.parseHTML(data[0].SupportHTML),
              arrSuportUl = $(helpCenter).find('ul'),
              arrSuportLiPhone = $(arrSuportUl[0]).find('li'),
              arrSuportLiEmail = $(arrSuportUl[1]).find('li');

                _.each(arrSuportLiPhone, function (mval, i) {
                    var objContact = {};
                    var contact = $(mval).find('span');
                    objContact.country = $(contact).find('strong').text().replace(':', '');
                    objContact.number = $(contact).clone().children().remove().end().text();
                    if (objContact.number) {
                        objContact.number = objContact.number.split("/");
                        var newobjContact = []
                        _.each(objContact.number, function (val, i) {
                            if (val.trim().charAt(0) === "+")
                                val = val.trim().substr(1, val.trim().length);
                            newobjContact.push(val);
                        });
                        objContact.number = newobjContact;
                        $rootScope.phoneContacts.push(objContact);
                    }
                });
                if (arrSuportLiEmail.length <= 0) {
                    var emailId = $(helpCenter[0]).find('a').not('.secondaryLink').text();
                    if (emailId != '' || emailId != "")
                        $rootScope.emailContacts.push({
                            email: emailId
                        });
                }
                _.each(arrSuportLiEmail, function (mval) {
                    var objContact = {};
                    objContact.country = $(mval).find('span').text().replace(':', '');
                    objContact.email = $(mval).find('a').text();
                    $rootScope.emailContacts.push(objContact);
                });
            }
            $rootScope.helpCenterUrl = data[0].HelpCenterUrl;
        }

        $scope.navOpen = function (navigationNum, thisEvent) {
            var $this = angular.element(thisEvent.currentTarget).parent();
            if ($('#overlay1').css('display') == 'block') {
                setTimeout(function () {
                    $('.overlayOkayButton').trigger('click');
                }, 200);
            }
            if ($this.hasClass('currentActive')) {
                if ($this.is(':last-child')) {
                    $this.parent().removeClass('nav-slide-active');
                }
                $this.removeClass('currentActive');
                for (var i = 0; i < $scope.sideNavComp.length; i++) {
                    $scope.sideNavComp[i] = false;
                }
                return false;
            } else {
                var $that = angular.element('.currentActive > a').parent();

                if ($that.is(':last-child')) {
                    $that.parent().removeClass('nav-slide-active');
                }
                $that.removeClass('currentActive');
                for (var i = 0; i < $scope.sideNavComp.length; i++) {
                    $scope.sideNavComp[i] = false;
                }

                $scope.sideNavComp[Number(angular.element(thisEvent.currentTarget).attr("idx"))] = true;
                if ($this.is(':last-child')) {
                    $this.parent().addClass('nav-slide-active');
                }
                $this.addClass('currentActive');
                return false;
            }
        };
        $scope.hideHeader = false;

        $rootScope.$on('hideheader', function (e, a) {
            $scope.hideHeader = a.condition;
        });
    };
})(angular);
